<style lang="scss">
    .charts-page {
        .page-title {
            color: #ff5b94;
            font-size: 30px;
            font-weight: 600;
            text-transform: uppercase;
            margin: 0 0 30px;
        }
        .beat-row-header {
            margin-top: -10px;
        }
        .table-header {
            color: #595e63;
            font-size: 13px;
            font-weight: 400;
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }
</style>
<template>
    <div class="charts-page padding">
        <h1 v-if="page" class="page-title" :style="$highlightColor">{{page.name}}</h1>

        <div v-if="loading" class="loading-icon text-center">
            <loading-icon></loading-icon>
        </div>

        <div v-else-if="beats.length > 0">
            <beat-row-header></beat-row-header>
            <div v-for="(beat, index) in beats" :key="index">
                <row-beat-container :beat="beat" :key="beat.id" :chart-number="index + 1"></row-beat-container>
            </div>
        </div>

        <div v-else>
            There are no beats which meet your request.
        </div>
    </div>
</template>

<script>
    import RowBeatContainer from '../rowbeatcontainer.vue'
    import BeatRowHeader from './../beatrowheader.vue'
    import LoadingIcon from './../loadingicon.vue'
    import Beat from './../../models/beat'
    import Playlist from './../../classes/playlist'
    import BeatRepository from './../../mixins/beat-repository'
    import Configure from './../../mixins/configure'

    export default {
        props: ['pageId'],
        created() {
            this.getBeats()
        },
        components: {
            RowBeatContainer, BeatRowHeader, LoadingIcon
        },
        data() {
            return {
                beats: [],
                loading: false,
                display: 'list'
            }
        },
        computed: {
            page() {
                if (this.pageId) {
                    let page = this.config.getPageById(this.pageId)
                    this.$store.commit("currentPage", {page: page})

                    return page
                }
            },
            config() {
                return this.$store.state.currentConfig
            },
            user() {
                return this.$store.state.user
            },
            limit() {
                if (this.page && this.page.size != undefined) {
                    return this.page.size
                }

                return 100
            },
            playlistManager() {
                return this.$store.state.playlistManager
            }
        },
        mixins: [BeatRepository, Configure],
        methods: {
            getBeats() {
                this.beats = []
                this.loading = true

                this.getUserChart(30, this.limit)
                    .then((response) => {
                        let beats = Beat.makeArray(response.data.items)
                        this.beats = beats
                        this.loading = false
                        this.playlistManager.setPagePlaylist(new Playlist(beats, this.page.name, this.pageId))
                    })
                    .catch(() => {
                        this.loading = false
                    })
            }
        },
        watch: {
            'page.size': {
                handler(val) {
                    this.getBeats()
                }
            }
        }
    }
</script>